import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { allRoutes } from "../routes/routeConfig";

const ProtectedRoute = () => {
  const location = useLocation();
  const token = useSelector((state) => state.auth?.token);
  const user = useSelector((state) => state.auth?.user);

  // التحقق من وجود التوكن والمستخدم
  if (!token || !user) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  // الحصول على تكوين المسار الحالي
  const currentPath = location.pathname;
  const routeConfig = allRoutes.find((route) => route.path === currentPath);

  // إذا لم يتم العثور على المسار، قم بالتوجيه إلى صفحة 404
  if (!routeConfig) {
    return <Navigate to="/404" replace />;
  }

  // صفحات عامة: إمرار مباشر
  if (routeConfig.public) {
    return <Outlet />;
  }

  // التحقق من الصلاحيات المطلوبة (المستخدم لديه صلاحية واحدة فقط تحدد الوصول)
  if (Array.isArray(routeConfig.requiredPermissions) && routeConfig.requiredPermissions.length > 0) {
    const role = String(user?.role || "").toLowerCase().trim();

    // (اختياري) دعم super-admin إن وُجد
    if (role !== "all") {
      const allowed = routeConfig.requiredPermissions
        .map((p) => String(p || "").toLowerCase().trim())
        .includes(role);

      if (!allowed) {
        console.log("Access Denied:", {
          userRole: user.role,
          required: routeConfig.requiredPermissions,
        });
        return <Navigate to="/404" replace />;
      }
    }
  }

  return <Outlet />;
};

export default ProtectedRoute;
